var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMemberDirectoryActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.8 2C0.8 1.33726 1.33726 0.8 2 0.8H4.92306C5.58581 0.8 6.12306 1.33726 6.12306 2V4.92306C6.12306 5.58581 5.58581 6.12306 4.92306 6.12306H2C1.33726 6.12306 0.8 5.58581 0.8 4.92306V2ZM8.87691 2C8.87691 1.33726 9.41417 0.8 10.0769 0.8H13C13.6627 0.8 14.2 1.33726 14.2 2V4.92306C14.2 5.58581 13.6627 6.12306 13 6.12306H10.0769C9.41417 6.12306 8.87691 5.58581 8.87691 4.92306V2ZM8.87691 10.0769C8.87691 9.41417 9.41417 8.87691 10.0769 8.87691H13C13.6627 8.87691 14.2 9.41417 14.2 10.0769V13C14.2 13.6627 13.6627 14.2 13 14.2H10.0769C9.41417 14.2 8.87691 13.6627 8.87691 13V10.0769ZM0.8 10.0769C0.8 9.41417 1.33726 8.87691 2 8.87691H4.92306C5.58581 8.87691 6.12306 9.41417 6.12306 10.0769V13C6.12306 13.6627 5.58581 14.2 4.92306 14.2H2C1.33726 14.2 0.8 13.6627 0.8 13V10.0769Z",
    stroke: "url(#paint0_linear)",
    strokeWidth: 1.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -0.5,
    y1: -1,
    x2: 14,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#5267A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74994"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberDirectoryActive);
export default __webpack_public_path__ + "static/media/member-directory--active.9cae94cf21ccd51fd06562d949c5f34d.svg";
export { ForwardRef as ReactComponent };